import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { IGetSubCategoriesShort, IGetSubCategoriesArguments } from 'types';
import { getSubCategoriesShortInfoV2 } from 'backend/subcategories';
import { useFetchData } from 'hooks/useFetchData';
import { MultipleSelect } from './MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './SubcategoriesMultipleSelect.module.scss';

interface IProps {
	setIDsSubcategory: (value: string[]) => void;
	index: number;
	IDSelectedCategory: Nullable<string>;
	IDsSelectedSubcategories: string[];
	IDSelectedRestaurant: string;
}

export const SubcategoriesMultipleSelect: React.FC<IProps> = React.memo(
	({ setIDsSubcategory, index, IDSelectedCategory, IDsSelectedSubcategories, IDSelectedRestaurant }) => {
		const [isFirstRender, setIsFirstRender] = useState(true);
		const { response, loading, refetch, responseError } = useFetchData<
			IGetSubCategoriesShort,
			IGetSubCategoriesArguments
		>(IDSelectedCategory ? getSubCategoriesShortInfoV2 : null, {
			categoryId: IDSelectedCategory ? IDSelectedCategory : '',
			restaurantId: IDSelectedRestaurant,
		});

		const handleRemove = useCallback(
			(id: string) => {
				const updatedSelectedItems = IDsSelectedSubcategories.filter((el) => el !== id);
				setIDsSubcategory(updatedSelectedItems);
			},
			[IDsSelectedSubcategories, setIDsSubcategory],
		);

		const subcategoryList = useMemo(() => {
			return IDsSelectedSubcategories.map((el) => {
				const label = response?.data.subCategories?.find((item) => item.id === el)?.name || '';

				return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
			});
		}, [IDsSelectedSubcategories, response, handleRemove]);

		useEffect(() => {
			if (!isFirstRender) {
				refetch();
			} else {
				setIsFirstRender(false);
			}
		}, [IDSelectedCategory]);

		return (
			<div className={style.container} data-test="SubcategoriesMultipleSelect">
				<div className={style.field}>
					<MultipleSelect
						data={response?.data.subCategories || []}
						isLoading={loading}
						refetch={refetch}
						responseError={responseError}
						setIDsSubcategory={setIDsSubcategory}
						index={index}
						IDSelectedCategory={IDSelectedCategory}
						IDsSelectedSubcategories={IDsSelectedSubcategories}
					/>
				</div>
				<div className={style.groupsList}>{subcategoryList}</div>
			</div>
		);
	},
);
